import type { Area } from "@/lib/areas";
import { casaTexto } from "@/lib/filtros/texto";

/**
 * CLAVES_AREAS son los parámetros que admite el listado de áreas (#247). La entidad no
 * tiene columna `activo` (D7), así que solo se ofrece el texto libre.
 */
export const CLAVES_AREAS = ["q"] as const;

/** FiltrosAreas es el objeto de filtros del listado de áreas tal como viaja en la URL. */
export type FiltrosAreas = Partial<Record<(typeof CLAVES_AREAS)[number], string>>;

/**
 * filtrarAreas aplica los filtros en el navegador (modo sin red, D2). Debe dar el MISMO
 * resultado que el SQL del servidor: ver la tabla de casos compartida en
 * backend/internal/factory/filtros_integration_test.go (TestFiltrosAreasHTTP).
 */
export function filtrarAreas(filas: Area[], filtros: FiltrosAreas): Area[] {
  return filas.filter((a) => casaTexto(filtros.q, a.nombre, a.descripcion));
}
